import type { DeliveryMethod } from './api'

/**
 * Human labels for a validation program's delivery method, in the operator
 * console's words: the "Delivery method" select on its Validations form
 * (ops `screens/Validations.tsx`). The tenant's Parkify contact sets the method
 * there, so the tenant reads the same name for it here.
 */
export const DELIVERY_METHOD_LABEL: Record<DeliveryMethod, string> = {
  coupon: 'Coupon code',
  qr: 'QR code',
  evalidation: 'E-validation (tablet)',
}

/**
 * A program with no method is a coupon (the API's default). A method this
 * build does not know yet reads "Other" rather than its raw key, which would
 * look like a typo next to the named ones.
 */
export function deliveryMethodLabel(method: string | null | undefined): string {
  if (!method) return DELIVERY_METHOD_LABEL.coupon
  return Object.hasOwn(DELIVERY_METHOD_LABEL, method)
    ? DELIVERY_METHOD_LABEL[method as DeliveryMethod]
    : 'Other'
}
